import React, { useEffect, useState, useRef } from 'react';

import { Title } from 'components/commons';
import CircleProgressBar from 'components/circle-progress-bar';
import TextSlideShow from 'components/text-slide-show';
import useTimer from 'hooks/timer';

import './awaiting-credit-rating-layout.style.scss';

type AwaitingCreditRatingLayoutProps = {
    estimatedLoadTimerInSeconds: number;
    maxPercentValue: number;
    screenProfile: 'default' | 'partners';
    onComplete(): void;
};

const AwaitingCreditRatingLayout: React.FC<AwaitingCreditRatingLayoutProps> = ({
    estimatedLoadTimerInSeconds,
    onComplete,
    screenProfile,
    maxPercentValue,
}) => {
    const timerSpeed = Math.floor(estimatedLoadTimerInSeconds * 3.25);
    const [progressValue, setProgressValue] = useState(0);
    const [getPercentage] = useTimer(timerSpeed);
    const savedCallback = useRef(null);

    const steps = [
        'buscando dados da <br class="d-block d-sm-none" />%s empresa…'.replace(
            '%s',
            screenProfile === 'default' ? 'sua' : ''
        ),
        'buscando dados <br class="d-block d-sm-none" />dos sócios…',
        'consultando bases <br class="d-block d-sm-none" />de dados públicas…',
        'calculando o perfil de crédito <br class="d-block d-sm-none" />da empresa…',
        'avaliando a possibilidade <br class="d-block d-sm-none" />de empréstimo.',
    ];

    useEffect(() => {
        savedCallback.current = () => {
            if (progressValue < 100) {
                if (progressValue < maxPercentValue) {
                    if (maxPercentValue === 100) {
                        if (progressValue + 10 > 100) {
                            setProgressValue(100);
                        } else {
                            setProgressValue(progressValue + 10);
                        }
                    } else {
                        const idealPercentage = getPercentage();

                        if (progressValue < idealPercentage) {
                            setProgressValue(idealPercentage);
                        } else {
                            setProgressValue(
                                progressValue +
                                    (Math.floor(Math.random() * 5) > 3 ? 1 : 0)
                            );
                        }
                    }
                }
            } else {
                onComplete();
            }
        };
    });
    useEffect(() => {
        const id = setInterval(() => savedCallback.current(), timerSpeed);

        return () => clearInterval(id);
    }, []);
    return (
        <div className="awaiting-credit-rating-layout">
            <div className="inner">
                <CircleProgressBar value={progressValue} />

                <Title>nos dê um minuto!</Title>

                <p>
                    <TextSlideShow steps={steps} />
                </p>

                <p>não feche seu navegador</p>
            </div>
        </div>
    );
};

export default AwaitingCreditRatingLayout;
